import { render, staticRenderFns } from "./FeatureDetail.vue?vue&type=template&id=cc3de83c&scoped=true&"
import script from "./FeatureDetail.vue?vue&type=script&lang=js&"
export * from "./FeatureDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeatureDetail.vue?vue&type=style&index=0&id=cc3de83c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3de83c",
  null
  
)

export default component.exports